// extracted by mini-css-extract-plugin
export default {"title":"ReportAnalytics_title__wTj+e","section-footer":"ReportAnalytics_section-footer__VQOiz","footer-button":"ReportAnalytics_footer-button__pEp1u"};